import { onBeforeUnmount, reactive, computed } from 'vue';

export default function useResizeObserver(element) {
    const data = reactive({
        width: 0,
        height: 0,
    });

    const onResize = () => {
        data.width = element.offsetWidth;
        data.height = element.offsetHeight;
    };

    const observer = new ResizeObserver(onResize);
    observer.observe(element);

    onBeforeUnmount(() => {
        observer.unobserve(element);
    });

    const width = computed(() => data.width);
    const height = computed(() => data.height);
    return { width, height };
}
